import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { dateToTimestamp, timestampToDate } from 'src/utils/fieldNormalizers';

import { ProgressPhoto, ProgressPhotoAsset } from './_types';

export const normalizeProgressPhoto = (progressPhoto): ProgressPhoto => {
  const camelized = camelcaseKeys(progressPhoto, {
    deep: true,
  });

  return {
    ...camelized,
    capturedAt: timestampToDate(camelized.capturedAt),
  } as ProgressPhoto;
};

export const denormalizeProgressPhoto = (
  progressPhoto: Partial<ProgressPhoto>
): any => {
  return decamelizeKeys(
    { ...progressPhoto, capturedAt: dateToTimestamp(progressPhoto.capturedAt) },
    { deep: true }
  );
};

export const normalizeProgressPhotoAsset = (asset: any): ProgressPhotoAsset => {
  return camelcaseKeys(asset, { deep: true }) as ProgressPhotoAsset;
};
